import { Modal } from 'antd';
import styled from 'styled-components';

export default styled(Modal)`
	// Add your styles here
`;
